import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'
  // ,'../../Content/sb-admin.css'
]
})
export class LogoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
